import http from "./HttpService";

let endpoint = `/reporting/analytics/vol-sci/`;

const getYearRange = async () => {
    const response = await http.get(`${endpoint}year-range`);
    return response;
};

const getVolunteerDemographicsDisability = async (year) => {
    const response = await http.get(`${endpoint}disabilities/${year}`);
    return response;
};

const getVolunteerDemographicsGender = async (year) => {
    const response = await http.get(`${endpoint}genders/${year}`);
    return response;
};

const getVolunteerDemographicsRace = async (year) => {
    const response = await http.get(`${endpoint}races/${year}`);
    return response;
};

const getVolunteerDemographicsAgeRange = async (year) => {
    const response = await http.get(`${endpoint}age-groups/${year}`);
    return response;
};

const getVolunteerDemographicsLanguages = async (year) => {
    const response = await http.get(`${endpoint}languages/${year}`);
    return response;
};

const getVolunteerSectors = async (year) => {
    const response = await http.get(`${endpoint}sectors/${year}`);
    return response;
};

const getVolunteerRoles = async (year) => {
    const response = await http.get(`${endpoint}roles/${year}`);
    return response;
};

const getVolunteerProvinces = async (year) => {
    const response = await http.get(`${endpoint}provinces/${year}`);
    return response;
};

const getVolunteerOccupations = async (year) => {
    const response = await http.get(`${endpoint}occupations/${year}`);
     return response;
};

const getVolunteerMotivations = async (year) => {
    const response = await http.get(`${endpoint}motivations/${year}`);
    return response;
};

const getVolunteerGrowth = async (year) => {
    const response = await http.get(`${endpoint}growth/${year}`);
    return response;
};

const getVolunteerDistricts = async (year) => {
    const response = await http.get(`${endpoint}districts/${year}`);
    return response;
};

const getVolunteerScienceGrowth = async (year) => {
  const response = await http.get(`${endpoint}growth/${year}`);
  return response;
};

const getVolunteerQualifications = async (year) => {
  const response = await http.get(`${endpoint}qualifications/${year}`);
  return response;
};


// eslint-disable-next-line import/no-anonymous-default-export
export default {
    getYearRange,
    getVolunteerDemographicsDisability,
    getVolunteerDemographicsGender,
    getVolunteerDemographicsRace,
    getVolunteerDemographicsAgeRange,
    getVolunteerDemographicsLanguages,
    getVolunteerSectors,
    getVolunteerRoles,
    getVolunteerProvinces,
    getVolunteerOccupations,
    getVolunteerMotivations,
    getVolunteerGrowth,
    getVolunteerDistricts,
    getVolunteerScienceGrowth,
    getVolunteerQualifications
}